import Box from '@mui/material/Box';

import { fShortenNumber } from 'src/utils/format-number';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function AccountStatistics({
  totalSales = 0,
  totalRating = 0,
  totalFollowers = 0,
  sx,
  ...other
}) {
  const { t } = useTranslate();

  return (
    <Box
      sx={[
        { mt: 1, gap: 2, width: 1, display: 'flex', typography: 'caption', color: 'text.disabled' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <div>
        {`${fShortenNumber(totalFollowers)} ${t(totalFollowers === 1 ? 'Follower' : 'Followers')}`}
      </div>

      <div>{`${fShortenNumber(totalSales)} ${t(totalSales === 1 ? 'Sale' : 'Sales')}`}</div>

      <Box sx={{ gap: 0.5, display: 'flex' }}>
        <Iconify
          icon="fluent-color:star-24"
          sx={{ width: { xs: 16, md: 13 }, height: { xs: 17, md: 16 } }}
        />
        {totalRating}
      </Box>
    </Box>
  );
}
